// extracted by mini-css-extract-plugin
export default {"container":"XNZ0JUC5f1p_coLnqGle","logo":"BLg2YSJXj28Wfb5aAoP7"};